export function getCurrentBreakpointParams(winWidth, breakpointsOptions, sliderHolder) {
    let key;
    let keyBuffer;

    for (key in breakpointsOptions) {
        if (breakpointsOptions.hasOwnProperty(key)) {

            if (parseInt(key) <= winWidth) {
                keyBuffer = key;
            } else {
                break;
            }
        }
    }

    return {
        breakpoint: keyBuffer,
        options: breakpointsOptions[keyBuffer]
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/get-current-breakpoint-params.js